export default [


    {
        header: 'Configuration',
        module: 'setting',
        profile: ['Admin','AdminSuper','Technician']
    },
    {
        title: 'Section',
        route: 'section',
        icon: 'FileIcon',
        module: 'setting',
        profile: ['Admin','AdminSuper','Technician']
    },
   
    {
      title: 'Entreprise',
      icon: 'HomeIcon',
       tag: '3',
      tagVariant: 'light-danger',
      module: 'setting',
      profile: ['Admin','AdminSuper','Technician'],
      children: [
    {
        title: 'Service',
        route: 'service',
    },
    {
        title: 'Direction - Cellule',
        route: 'direction_cellule',

    },
    {
        title: 'Peage',
        route: 'peage',

    },
    
      ],
    },
    {
        icon: 'SettingsIcon',
        title: 'Paramètre',
        route: 'setting',
        module: 'setting',
        profile: ['Admin','AdminSuper','Technician'],
    },
    {
        title: 'Exclus des relances',
        route: 'reminder_blocklist',
        icon: 'UserXIcon',
        module: 'setting',
        profile: ['Admin','AdminSuper','Technician'],
    }

]